// extracted by mini-css-extract-plugin
module.exports = {"root":"NoShows_root__LC0Wu"};